import React from "react";
import "./FlyingText.css";

function FlyingText() {
  return (
    <div id="fly-in">
      <div>Tech Master GoGo</div>
      <div>Content Creator</div>
      <div>Website Development</div>
      <div>Social Media Management</div>
      {/* <div>and many more</div>
      <div>Happy Clients</div>
      <div>Experienced Developers</div> */}
    </div>
  );
}

export default FlyingText;
